import { registerNodeTypes } from '../core/registry';
import { adjustments } from './adjust';
import { channelNodes } from './channel';
import { filters } from './filters';
import { generators } from './generators';
import { meshNodes } from './mesh';
import { outputNodes } from './output';

export { BLEND_MODES } from './filters';
export { OUTPUT_CHANNELS } from './output';

let registered = false;

/**
 * Populate the node registry.
 *
 * Idempotent because tests, the app, and the schema dump all call it, and
 * `registerNodeType` deliberately throws on duplicate ids.
 */
export function registerBuiltinNodes(): void {
  if (registered) return;
  registered = true;
  registerNodeTypes([
    ...generators,
    ...filters,
    ...adjustments,
    ...channelNodes,
    ...meshNodes,
    ...outputNodes,
  ]);
}
